import { render } from "./BondDetailComponent.vue?vue&type=template&id=996b1878&scoped=true"
import script from "./BondDetailComponent.vue?vue&type=script&lang=js"
export * from "./BondDetailComponent.vue?vue&type=script&lang=js"

import "./BondDetailComponent.vue?vue&type=style&index=0&id=996b1878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996b1878"]])

export default __exports__